import type { School } from '@gov-nx/api';
import { useSchoolSearchAutocomplete } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { TypeOfSchool } from '@gov-nx/core/types';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

export interface SchoolSearchAutocompleteProps extends Omit<
	FormAutocompleteProps<School>,
	'field'
> {
	field: Omit<
		FormAutocompleteProps<School>['field'],
		'templateResolver' | 'keyResolver' | 'valueResolver' | 'searchCallback'
	>;
	type: TypeOfSchool;
}

export const SchoolSearchAutocomplete = (
	props: SchoolSearchAutocompleteProps
) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = useSchoolSearchAutocomplete({
		type: props.type,
	});

	return (
		<FormAutocomplete<School>
			label={props.label}
			field={{
				...props.field,
				messageEmpty:
					props.field.messageEmpty ?? tn('naseptavac.pole.zadny-vysledek'),
				templateResolver: (item) => `${item.nazev} (${item.datovaSchrankaId})`,
				keyResolver: (item) => `${item.datovaSchrankaId}`,
				valueResolver: (item) => `${item.nazev} (${item.datovaSchrankaId})`,
				searchCallback,
			}}
		/>
	);
};
